import { gql } from 'graphql-tag'

import * as Types from './tribe-global-graphql.generated.js'

export type ActionFields = 'basic' | 'all' | Record<string, never>

export const ActionGQLFields = (fields: ActionFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        status
      `
}

export interface CustomAppFields {
  banner?: MediaFields
  customCodes?: AppCustomCodesFields
  embeds?: EmbedFields
  favicon?: MediaFields
  image?: MediaFields
  images?: MediaFields
  network?: NetworkFields
}
export type AppFields = 'basic' | 'all' | CustomAppFields

export const AppGQLFields = (fields: AppFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      banner: 'basic',
      customCodes: 'basic',
      embeds: 'basic',
      favicon: 'basic',
      image: 'basic',
      images: 'basic',
      network: 'basic',
    }
  }
  return `
        __typename
        about
authorName
authorUrl

    ${
      fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``
    }
  
bannerId
clientId
clientSecret
comingSoon
createdAt
createdById

    ${
      fields.customCodes
        ? `
      customCodes {
        ${AppCustomCodesGQLFields(fields.customCodes)}
      }
    `
        : ``
    }
  
description
docsUrl
embedIds

    ${
      fields.embeds
        ? `
      embeds {
        ${EmbedGQLFields(fields.embeds)}
      }
    `
        : ``
    }
  

    ${
      fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``
    }
  
faviconId
federatedSearchEnabled
federatedSearchUrl
id

    ${
      fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``
    }
  
imageId
imageIds

    ${
      fields.images
        ? `
      images {
        ${MediaGQLFields(fields.images)}
      }
    `
        : ``
    }
  
installed
interactionUrl
isConsentManagementPlatform
locked
name

    ${
      fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``
    }
  
networkId
onFreePlan
privacyPolicyUrl
redirectUris
requiredPermissions

secretToken
slug
standing
status
termsOfServiceUrl
updatedAt
updatedById
webhookSignSecret
webhookSubscriptions
webhookUrl
      `
}

export interface CustomAppCollaboratorFields {
  app?: AppFields
}
export type AppCollaboratorFields =
  | 'basic'
  | 'all'
  | CustomAppCollaboratorFields

export const AppCollaboratorGQLFields = (fields: AppCollaboratorFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      app: 'basic',
    }
  }
  return `
        __typename
        addedById

    ${
      fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``
    }
  
appId
createdAt
email
id
type
      `
}

export type AppCustomCodesFields = 'basic' | 'all' | Record<string, never>

export const AppCustomCodesGQLFields = (fields: AppCustomCodesFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        body
head
      `
}

export interface CustomAppEdgeFields {
  node?: AppFields
}
export type AppEdgeFields = 'basic' | 'all' | CustomAppEdgeFields

export const AppEdgeGQLFields = (fields: AppEdgeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      node: 'basic',
    }
  }
  return `
        __typename
        cursor

    ${
      fields.node
        ? `
      node {
        ${AppGQLFields(fields.node)}
      }
    `
        : ``
    }
  
      `
}

export type AppPublicationFields = 'basic' | 'all' | Record<string, never>

export const AppPublicationGQLFields = (fields: AppPublicationFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        addedById
createdAt
id
itemId
networkId
      `
}

export interface CustomAppRequiredTemplatesFields {
  postTypeTemplates?: TemplateFields
}
export type AppRequiredTemplatesFields =
  | 'basic'
  | 'all'
  | CustomAppRequiredTemplatesFields

export const AppRequiredTemplatesGQLFields = (
  fields: AppRequiredTemplatesFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      postTypeTemplates: 'basic',
    }
  }
  return `
        __typename
        postTypeTemplateIds

    ${
      fields.postTypeTemplates
        ? `
      postTypeTemplates {
        ${TemplateGQLFields(fields.postTypeTemplates)}
      }
    `
        : ``
    }
  
      `
}

export type AppSettingsFields = 'basic' | 'all' | Record<string, never>

export const AppSettingsGQLFields = (fields: AppSettingsFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        appId
context
entityId
id
networkId
settings
      `
}

export type AppTokenFields = 'basic' | 'all' | Record<string, never>

export const AppTokenGQLFields = (fields: AppTokenFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        accessToken
gatewayUrl
      `
}

export type AvailabilityFields = 'basic' | 'all' | Record<string, never>

export const AvailabilityGQLFields = (fields: AvailabilityFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        available
      `
}

export interface CustomBaseCustomFieldSchemaFields {
  items?: BaseCustomFieldSchemaFields
  properties?: BaseCustomFieldSchemaFields
  typeOptions?: CustomFieldTypeOptionsFields
  validators?: CustomFieldValidatorFields
}
export type BaseCustomFieldSchemaFields =
  | 'basic'
  | 'all'
  | CustomBaseCustomFieldSchemaFields

export const BaseCustomFieldSchemaGQLFields = (
  fields: BaseCustomFieldSchemaFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      items: 'basic',
      properties: 'basic',
      typeOptions: 'basic',
      validators: 'basic',
    }
  }
  return `
        __typename
        archived
description
externalKeys

    ${
      fields.items
        ? `
      items {
        ${BaseCustomFieldSchemaGQLFields(fields.items)}
      }
    `
        : ``
    }
  
key
name

    ${
      fields.properties
        ? `
      properties {
        ${BaseCustomFieldSchemaGQLFields(fields.properties)}
      }
    `
        : ``
    }
  
required
type

    ${
      fields.typeOptions
        ? `
      typeOptions {
        ${CustomFieldTypeOptionsGQLFields(fields.typeOptions)}
      }
    `
        : ``
    }
  

    ${
      fields.validators
        ? `
      validators {
        ${CustomFieldValidatorGQLFields(fields.validators)}
      }
    `
        : ``
    }
  
      `
}

export type BlockFields = 'basic' | 'all' | Record<string, never>

export const BlockGQLFields = (fields: BlockFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        children
id
name
output
props
      `
}

export type CustomFieldPrivacyFields = 'basic' | 'all' | Record<string, never>

export const CustomFieldPrivacyGQLFields = (
  fields: CustomFieldPrivacyFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        allow
      `
}

export interface CustomCustomFieldSchemaFields {
  items?: BaseCustomFieldSchemaFields
  properties?: BaseCustomFieldSchemaFields
  readPrivacy?: CustomFieldPrivacyFields
  settings?: CustomFieldSettingsFields
  typeOptions?: CustomFieldTypeOptionsFields
  validators?: CustomFieldValidatorFields
  writePrivacy?: CustomFieldPrivacyFields
}
export type CustomFieldSchemaFields =
  | 'basic'
  | 'all'
  | CustomCustomFieldSchemaFields

export const CustomFieldSchemaGQLFields = (fields: CustomFieldSchemaFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      items: 'basic',
      properties: 'basic',
      readPrivacy: 'basic',
      settings: 'basic',
      typeOptions: 'basic',
      validators: 'basic',
      writePrivacy: 'basic',
    }
  }
  return `
        __typename
        archived
default
description
externalKeys

    ${
      fields.items
        ? `
      items {
        ${BaseCustomFieldSchemaGQLFields(fields.items)}
      }
    `
        : ``
    }
  
key
name

    ${
      fields.properties
        ? `
      properties {
        ${BaseCustomFieldSchemaGQLFields(fields.properties)}
      }
    `
        : ``
    }
  

    ${
      fields.readPrivacy
        ? `
      readPrivacy {
        ${CustomFieldPrivacyGQLFields(fields.readPrivacy)}
      }
    `
        : ``
    }
  
required
searchable

    ${
      fields.settings
        ? `
      settings {
        ${CustomFieldSettingsGQLFields(fields.settings)}
      }
    `
        : ``
    }
  
type

    ${
      fields.typeOptions
        ? `
      typeOptions {
        ${CustomFieldTypeOptionsGQLFields(fields.typeOptions)}
      }
    `
        : ``
    }
  

    ${
      fields.validators
        ? `
      validators {
        ${CustomFieldValidatorGQLFields(fields.validators)}
      }
    `
        : ``
    }
  

    ${
      fields.writePrivacy
        ? `
      writePrivacy {
        ${CustomFieldPrivacyGQLFields(fields.writePrivacy)}
      }
    `
        : ``
    }
  
      `
}

export type CustomFieldSettingsFields = 'basic' | 'all' | Record<string, never>

export const CustomFieldSettingsGQLFields = (
  fields: CustomFieldSettingsFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        key
value
      `
}

export type CustomFieldTypeOptionsFields =
  | 'basic'
  | 'all'
  | Record<string, never>

export const CustomFieldTypeOptionsGQLFields = (
  fields: CustomFieldTypeOptionsFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        dateType
numberType
relationType
richTextType
textType
      `
}

export type CustomFieldValidatorFields = 'basic' | 'all' | Record<string, never>

export const CustomFieldValidatorGQLFields = (
  fields: CustomFieldValidatorFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        customErrorMessage
validation
value
      `
}

export interface CustomDynamicBlockFields {
  app?: AppFields
  favicon?: MediaFields
  image?: MediaFields
}
export type DynamicBlockFields = 'basic' | 'all' | CustomDynamicBlockFields

export const DynamicBlockGQLFields = (fields: DynamicBlockFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      app: 'basic',
      favicon: 'basic',
      image: 'basic',
    }
  }
  return `
        __typename
        about

    ${
      fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``
    }
  
appId
contexts
createdAt
createdById
description

    ${
      fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``
    }
  
faviconId
id

    ${
      fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``
    }
  
imageId
interactionUrl
key
maxSize
name
staffOnly
updatedAt
updatedById
      `
}

export interface CustomDynamicBlockEdgeFields {
  node?: DynamicBlockFields
}
export type DynamicBlockEdgeFields =
  | 'basic'
  | 'all'
  | CustomDynamicBlockEdgeFields

export const DynamicBlockEdgeGQLFields = (fields: DynamicBlockEdgeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      node: 'basic',
    }
  }
  return `
        __typename
        cursor

    ${
      fields.node
        ? `
      node {
        ${DynamicBlockGQLFields(fields.node)}
      }
    `
        : ``
    }
  
      `
}

export type EmailValidationResultFields =
  | 'basic'
  | 'all'
  | Record<string, never>

export const EmailValidationResultGQLFields = (
  fields: EmailValidationResultFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        suggestion
valid
      `
}

export type EmbedFields = 'basic' | 'all' | Record<string, never>

export const EmbedGQLFields = (fields: EmbedFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        author
author_url
description
html
id
options
provider_name
thumbnail_height
thumbnail_url
thumbnail_width
title
type
url
      `
}

export type EmojiFields = 'basic' | 'all' | Record<string, never>

export const EmojiGQLFields = (fields: EmojiFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        id
text
      `
}

export type EventTypeFields = 'basic' | 'all' | Record<string, never>

export const EventTypeGQLFields = (fields: EventTypeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        description
name
noun
requiredScope
shortDescription
verb
      `
}

export type FileFields = 'basic' | 'all' | Record<string, never>

export const FileGQLFields = (fields: FileFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        downloadUrl
extension
id
name
size
url
      `
}

export interface CustomGlobalMemberFields {
  profilePicture?: MediaFields
}
export type GlobalMemberFields = 'basic' | 'all' | CustomGlobalMemberFields

export const GlobalMemberGQLFields = (fields: GlobalMemberFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      profilePicture: 'basic',
    }
  }
  return `
        __typename
        createdAt
email
id
joinedReferralProgram
locale
name

    ${
      fields.profilePicture
        ? `
      profilePicture {
        ${MediaGQLFields(fields.profilePicture)}
      }
    `
        : ``
    }
  
profilePictureId
referrerCode
updatedAt
      `
}

export type GlobalTokenFields = 'basic' | 'all' | Record<string, never>

export const GlobalTokenGQLFields = (fields: GlobalTokenFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        accessToken
email
      `
}

export type GlyphFields = 'basic' | 'all' | Record<string, never>

export const GlyphGQLFields = (fields: GlyphFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        id
text
variant
      `
}

export interface CustomHubContentFields {
  attachments?: FileFields
  embeds?: EmbedFields
  fields?: HubContentCustomFieldFields
  images?: MediaFields
  thumbnail?: MediaFields
}
export type HubContentFields = 'basic' | 'all' | CustomHubContentFields

export const HubContentGQLFields = (fields: HubContentFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      attachments: 'basic',
      embeds: 'basic',
      fields: 'basic',
      images: 'basic',
      thumbnail: 'basic',
    }
  }
  return `
        __typename
        attachmentIds

    ${
      fields.attachments
        ? `
      attachments {
        ${FileGQLFields(fields.attachments)}
      }
    `
        : ``
    }
  
createdAt
description
embedIds

    ${
      fields.embeds
        ? `
      embeds {
        ${EmbedGQLFields(fields.embeds)}
      }
    `
        : ``
    }
  

    ${
      fields.fields
        ? `
      fields {
        ${HubContentCustomFieldGQLFields(fields.fields)}
      }
    `
        : ``
    }
  
id
imageIds

    ${
      fields.images
        ? `
      images {
        ${MediaGQLFields(fields.images)}
      }
    `
        : ``
    }
  
language
locked
postTypeId
publishedAt
slug
tagIds

    ${
      fields.thumbnail
        ? `
      thumbnail {
        ${MediaGQLFields(fields.thumbnail)}
      }
    `
        : ``
    }
  
thumbnailId
title
updatedAt
      `
}

export interface CustomHubContentCustomFieldFields {
  relationEntities?: HubContentCustomFieldRelationFields
}
export type HubContentCustomFieldFields =
  | 'basic'
  | 'all'
  | CustomHubContentCustomFieldFields

export const HubContentCustomFieldGQLFields = (
  fields: HubContentCustomFieldFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      relationEntities: 'basic',
    }
  }
  return `
        __typename
        key

    ${
      fields.relationEntities
        ? `
      relationEntities {
        ${HubContentCustomFieldRelationGQLFields(fields.relationEntities)}
      }
    `
        : ``
    }
  
value
      `
}

export interface CustomHubContentCustomFieldRelationFields {
  medias?: MediaFields
}
export type HubContentCustomFieldRelationFields =
  | 'basic'
  | 'all'
  | CustomHubContentCustomFieldRelationFields

export const HubContentCustomFieldRelationGQLFields = (
  fields: HubContentCustomFieldRelationFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      medias: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.medias
        ? `
      medias {
        ${MediaGQLFields(fields.medias)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomImageFields {
  urls?: MediaUrlsFields
}
export type ImageFields = 'basic' | 'all' | CustomImageFields

export const ImageGQLFields = (fields: ImageFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      urls: 'basic',
    }
  }
  return `
        __typename
        cropHeight
cropWidth
cropX
cropY
cropZoom
dominantColorHex
downloadUrl
dpi
height
id
name
url

    ${
      fields.urls
        ? `
      urls {
        ${MediaUrlsGQLFields(fields.urls)}
      }
    `
        : ``
    }
  
width
      `
}

export type InvitationAcceptResultFields =
  | 'basic'
  | 'all'
  | Record<string, never>

export const InvitationAcceptResultGQLFields = (
  fields: InvitationAcceptResultFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        accessToken
email
errorMessage
networkId
networkPath
status
      `
}

export interface CustomMediaFields {
  onEmoji?: EmojiFields
  onFile?: FileFields
  onGlyph?: GlyphFields
  onImage?: ImageFields
}
export type MediaFields = 'basic' | 'all' | CustomMediaFields

export const MediaGQLFields = (fields: MediaFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      onEmoji: 'basic',
      onFile: 'basic',
      onGlyph: 'basic',
      onImage: 'basic',
    }
  }
  return `
        __typename
        
          ${
            fields.onEmoji
              ? `
            ... on Emoji {
              ${EmojiGQLFields(fields.onEmoji)}
            }
          `
              : ``
          }
        

          ${
            fields.onFile
              ? `
            ... on File {
              ${FileGQLFields(fields.onFile)}
            }
          `
              : ``
          }
        

          ${
            fields.onGlyph
              ? `
            ... on Glyph {
              ${GlyphGQLFields(fields.onGlyph)}
            }
          `
              : ``
          }
        

          ${
            fields.onImage
              ? `
            ... on Image {
              ${ImageGQLFields(fields.onImage)}
            }
          `
              : ``
          }
        
      `
}

export type MediaUrlsFields = 'basic' | 'all' | Record<string, never>

export const MediaUrlsGQLFields = (fields: MediaUrlsFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        full
large
medium
small
thumb
      `
}

export interface CustomMutationFields {
  acceptCollaboratorInvitation?: {
    fields: InvitationAcceptResultFields
    variables: Types.MutationAcceptCollaboratorInvitationArgs
  }

  addAppCollaborator?: {
    fields: AppCollaboratorFields
    variables: Types.MutationAddAppCollaboratorArgs
  }

  createApp?: {
    fields: AppFields
    variables: Types.MutationCreateAppArgs
  }

  createDynamicBlock?: {
    fields: DynamicBlockFields
    variables: Types.MutationCreateDynamicBlockArgs
  }

  createEmojis?: {
    fields: EmojiFields
    variables: Types.MutationCreateEmojisArgs
  }

  createImages?: {
    fields: SignedUrlFields
    variables: Types.MutationCreateImagesArgs
  }

  createNetwork?: {
    fields: NetworkOtpFields
    variables: Types.MutationCreateNetworkArgs
  }

  createPostTypeTemplate?: {
    fields: TemplateFields
    variables: Types.MutationCreatePostTypeTemplateArgs
  }

  createShortcut?: {
    fields: ShortcutFields
    variables: Types.MutationCreateShortcutArgs
  }

  deleteApp?: {
    fields: ActionFields
    variables: Types.MutationDeleteAppArgs
  }

  deleteAppSetting?: {
    fields: AppSettingsFields
    variables: Types.MutationDeleteAppSettingArgs
  }

  deleteDynamicBlock?: {
    fields: ActionFields
    variables: Types.MutationDeleteDynamicBlockArgs
  }

  deleteNetwork?: {
    fields: ActionFields
    variables: Types.MutationDeleteNetworkArgs
  }

  deleteShortcut?: {
    fields: ActionFields
    variables: Types.MutationDeleteShortcutArgs
  }

  disableDefaultDynamicBlock?: {
    fields: ActionFields
    variables: Types.MutationDisableDefaultDynamicBlockArgs
  }

  enableDefaultDynamicBlock?: {
    fields: DynamicBlockFields
    variables: Types.MutationEnableDefaultDynamicBlockArgs
  }

  joinReferralProgram?: GlobalMemberFields

  publishApp?: {
    fields: ActionFields
    variables: Types.MutationPublishAppArgs
  }

  publishAppPrivately?: {
    fields: AppPublicationFields
    variables: Types.MutationPublishAppPrivatelyArgs
  }

  regenerateClientSecret?: {
    fields: AppFields
    variables: Types.MutationRegenerateClientSecretArgs
  }

  removeAppCollaborator?: {
    fields: ActionFields
    variables: Types.MutationRemoveAppCollaboratorArgs
  }

  requestGlobalTokenCode?: {
    fields: ActionFields
    variables: Types.MutationRequestGlobalTokenCodeArgs
  }

  resendGlobalTokenCode?: {
    fields: ActionFields
    variables: Types.MutationResendGlobalTokenCodeArgs
  }

  sendNotifications?: {
    fields: SendNotificationsFields
    variables: Types.MutationSendNotificationsArgs
  }

  testAppWebhook?: {
    fields: ActionFields
    variables: Types.MutationTestAppWebhookArgs
  }

  unPublishAppPrivately?: {
    fields: ActionFields
    variables: Types.MutationUnPublishAppPrivatelyArgs
  }

  unpublishApp?: {
    fields: ActionFields
    variables: Types.MutationUnpublishAppArgs
  }

  updateApp?: {
    fields: AppFields
    variables: Types.MutationUpdateAppArgs
  }

  updateAppSetting?: {
    fields: AppSettingsFields
    variables: Types.MutationUpdateAppSettingArgs
  }

  updateAuthMember?: {
    fields: GlobalMemberFields
    variables: Types.MutationUpdateAuthMemberArgs
  }

  updateDynamicBlock?: {
    fields: DynamicBlockFields
    variables: Types.MutationUpdateDynamicBlockArgs
  }

  updateShortcut?: {
    fields: ShortcutFields
    variables: Types.MutationUpdateShortcutArgs
  }

  validateEmail?: {
    fields: EmailValidationResultFields
    variables: Types.MutationValidateEmailArgs
  }
}
export type MutationFields = 'basic' | 'all' | CustomMutationFields

export interface CustomNetworkFields {
  activeTheme?: ThemeFields
  favicon?: MediaFields
  images?: NetworkImagesFields
  logo?: MediaFields
}
export type NetworkFields = 'basic' | 'all' | CustomNetworkFields

export const NetworkGQLFields = (fields: NetworkFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      activeTheme: 'basic',
      favicon: 'basic',
      images: 'basic',
      logo: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.activeTheme
        ? `
      activeTheme {
        ${ThemeGQLFields(fields.activeTheme)}
      }
    `
        : ``
    }
  
aliases
createdAt
description
domain
domainSubfolder

    ${
      fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``
    }
  
faviconId
gatewayUrl
id

    ${
      fields.images
        ? `
      images {
        ${NetworkImagesGQLFields(fields.images)}
      }
    `
        : ``
    }
  
isOwner

    ${
      fields.logo
        ? `
      logo {
        ${MediaGQLFields(fields.logo)}
      }
    `
        : ``
    }
  
logoId
membership
name
overUsedAt
planName
status
visibility
willUnpublishAt
      `
}

export interface CustomNetworkEdgeFields {
  node?: NetworkFields
}
export type NetworkEdgeFields = 'basic' | 'all' | CustomNetworkEdgeFields

export const NetworkEdgeGQLFields = (fields: NetworkEdgeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      node: 'basic',
    }
  }
  return `
        __typename
        cursor

    ${
      fields.node
        ? `
      node {
        ${NetworkGQLFields(fields.node)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomNetworkImagesFields {
  darkFavicon?: MediaFields
  darkLogo?: MediaFields
  darkMobileLogo?: MediaFields
  lightFavicon?: MediaFields
  lightLogo?: MediaFields
  lightMobileLogo?: MediaFields
}
export type NetworkImagesFields = 'basic' | 'all' | CustomNetworkImagesFields

export const NetworkImagesGQLFields = (fields: NetworkImagesFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      darkFavicon: 'basic',
      darkLogo: 'basic',
      darkMobileLogo: 'basic',
      lightFavicon: 'basic',
      lightLogo: 'basic',
      lightMobileLogo: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.darkFavicon
        ? `
      darkFavicon {
        ${MediaGQLFields(fields.darkFavicon)}
      }
    `
        : ``
    }
  

    ${
      fields.darkLogo
        ? `
      darkLogo {
        ${MediaGQLFields(fields.darkLogo)}
      }
    `
        : ``
    }
  

    ${
      fields.darkMobileLogo
        ? `
      darkMobileLogo {
        ${MediaGQLFields(fields.darkMobileLogo)}
      }
    `
        : ``
    }
  

    ${
      fields.lightFavicon
        ? `
      lightFavicon {
        ${MediaGQLFields(fields.lightFavicon)}
      }
    `
        : ``
    }
  

    ${
      fields.lightLogo
        ? `
      lightLogo {
        ${MediaGQLFields(fields.lightLogo)}
      }
    `
        : ``
    }
  

    ${
      fields.lightMobileLogo
        ? `
      lightMobileLogo {
        ${MediaGQLFields(fields.lightMobileLogo)}
      }
    `
        : ``
    }
  
      `
}

export type NetworkOtpFields = 'basic' | 'all' | Record<string, never>

export const NetworkOtpGQLFields = (fields: NetworkOtpFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        domain
networkPath
otp
      `
}

export type PageInfoFields = 'basic' | 'all' | Record<string, never>

export const PageInfoGQLFields = (fields: PageInfoFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        endCursor
hasNextPage
      `
}

export interface CustomPaginatedAppFields {
  edges?: AppEdgeFields
  nodes?: AppFields
  pageInfo?: PageInfoFields
}
export type PaginatedAppFields = 'basic' | 'all' | CustomPaginatedAppFields

export const PaginatedAppGQLFields = (fields: PaginatedAppFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      edges: 'basic',
      nodes: 'basic',
      pageInfo: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.edges
        ? `
      edges {
        ${AppEdgeGQLFields(fields.edges)}
      }
    `
        : ``
    }
  

    ${
      fields.nodes
        ? `
      nodes {
        ${AppGQLFields(fields.nodes)}
      }
    `
        : ``
    }
  

    ${
      fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``
    }
  
totalCount
      `
}

export interface CustomPaginatedDynamicBlockFields {
  edges?: DynamicBlockEdgeFields
  nodes?: DynamicBlockFields
  pageInfo?: PageInfoFields
}
export type PaginatedDynamicBlockFields =
  | 'basic'
  | 'all'
  | CustomPaginatedDynamicBlockFields

export const PaginatedDynamicBlockGQLFields = (
  fields: PaginatedDynamicBlockFields,
) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      edges: 'basic',
      nodes: 'basic',
      pageInfo: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.edges
        ? `
      edges {
        ${DynamicBlockEdgeGQLFields(fields.edges)}
      }
    `
        : ``
    }
  

    ${
      fields.nodes
        ? `
      nodes {
        ${DynamicBlockGQLFields(fields.nodes)}
      }
    `
        : ``
    }
  

    ${
      fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``
    }
  
totalCount
      `
}

export interface CustomPaginatedShortcutFields {
  edges?: ShortcutEdgeFields
  nodes?: ShortcutFields
  pageInfo?: PageInfoFields
}
export type PaginatedShortcutFields =
  | 'basic'
  | 'all'
  | CustomPaginatedShortcutFields

export const PaginatedShortcutGQLFields = (fields: PaginatedShortcutFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      edges: 'basic',
      nodes: 'basic',
      pageInfo: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.edges
        ? `
      edges {
        ${ShortcutEdgeGQLFields(fields.edges)}
      }
    `
        : ``
    }
  

    ${
      fields.nodes
        ? `
      nodes {
        ${ShortcutGQLFields(fields.nodes)}
      }
    `
        : ``
    }
  

    ${
      fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``
    }
  
totalCount
      `
}

export interface CustomPaginatedTemplateFields {
  edges?: TemplateEdgeFields
  nodes?: TemplateFields
  pageInfo?: PageInfoFields
}
export type PaginatedTemplateFields =
  | 'basic'
  | 'all'
  | CustomPaginatedTemplateFields

export const PaginatedTemplateGQLFields = (fields: PaginatedTemplateFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      edges: 'basic',
      nodes: 'basic',
      pageInfo: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.edges
        ? `
      edges {
        ${TemplateEdgeGQLFields(fields.edges)}
      }
    `
        : ``
    }
  

    ${
      fields.nodes
        ? `
      nodes {
        ${TemplateGQLFields(fields.nodes)}
      }
    `
        : ``
    }
  

    ${
      fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``
    }
  
totalCount
      `
}

export interface CustomQueryFields {
  app?: {
    fields: AppFields
    variables: Types.QueryAppArgs
  }

  appCollaborators?: {
    fields: AppCollaboratorFields
    variables: Types.QueryAppCollaboratorsArgs
  }

  appPublications?: {
    fields: AppPublicationFields
    variables: Types.QueryAppPublicationsArgs
  }

  appSettings?: {
    fields: AppSettingsFields
    variables: Types.QueryAppSettingsArgs
  }

  apps?: {
    fields: PaginatedAppFields
    variables: Types.QueryAppsArgs
  }

  authMember?: GlobalMemberFields

  checkAppSlugAvailability?: {
    fields: AvailabilityFields
    variables: Types.QueryCheckAppSlugAvailabilityArgs
  }

  dynamicBlock?: {
    fields: DynamicBlockFields
    variables: Types.QueryDynamicBlockArgs
  }

  dynamicBlocks?: {
    fields: PaginatedDynamicBlockFields
    variables: Types.QueryDynamicBlocksArgs
  }

  embed?: {
    fields: EmbedFields
    variables: Types.QueryEmbedArgs
  }

  eventTypes?: EventTypeFields

  globalToken?: {
    fields: GlobalTokenFields
    variables: Types.QueryGlobalTokenArgs
  }

  limitedToken?: {
    fields: AppTokenFields
    variables: Types.QueryLimitedTokenArgs
  }

  loginWithSsoCode?: {
    fields: GlobalTokenFields
    variables: Types.QueryLoginWithSsoCodeArgs
  }

  media?: {
    fields: MediaFields
    variables: Types.QueryMediaArgs
  }

  networkOtp?: {
    fields: NetworkOtpFields
    variables: Types.QueryNetworkOtpArgs
  }

  networks?: NetworkFields

  shortcut?: {
    fields: ShortcutFields
    variables: Types.QueryShortcutArgs
  }

  shortcuts?: {
    fields: PaginatedShortcutFields
    variables: Types.QueryShortcutsArgs
  }

  ssoUrl?: {
    fields: SsoUrlFields
    variables: Types.QuerySsoUrlArgs
  }

  templates?: {
    fields: PaginatedTemplateFields
    variables: Types.QueryTemplatesArgs
  }
}
export type QueryFields = 'basic' | 'all' | CustomQueryFields

export interface CustomSendNotificationsFields {
  templateData?: TemplateDataFields
}
export type SendNotificationsFields =
  | 'basic'
  | 'all'
  | CustomSendNotificationsFields

export const SendNotificationsGQLFields = (fields: SendNotificationsFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      templateData: 'basic',
    }
  }
  return `
        __typename
        createdAt
id
networkId
template

    ${
      fields.templateData
        ? `
      templateData {
        ${TemplateDataGQLFields(fields.templateData)}
      }
    `
        : ``
    }
  
updatedAt
      `
}

export interface CustomShortcutFields {
  favicon?: MediaFields
  states?: ShortcutStateFields
}
export type ShortcutFields = 'basic' | 'all' | CustomShortcutFields

export const ShortcutGQLFields = (fields: ShortcutFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      favicon: 'basic',
      states: 'basic',
    }
  }
  return `
        __typename
        appId
context
createdAt
createdById
description
entityType

    ${
      fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``
    }
  
faviconId
id
interactionUrl
key
name

    ${
      fields.states
        ? `
      states {
        ${ShortcutStateGQLFields(fields.states)}
      }
    `
        : ``
    }
  
updatedAt
updatedById
      `
}

export interface CustomShortcutEdgeFields {
  node?: ShortcutFields
}
export type ShortcutEdgeFields = 'basic' | 'all' | CustomShortcutEdgeFields

export const ShortcutEdgeGQLFields = (fields: ShortcutEdgeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      node: 'basic',
    }
  }
  return `
        __typename
        cursor

    ${
      fields.node
        ? `
      node {
        ${ShortcutGQLFields(fields.node)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomShortcutStateFields {
  favicon?: MediaFields
}
export type ShortcutStateFields = 'basic' | 'all' | CustomShortcutStateFields

export const ShortcutStateGQLFields = (fields: ShortcutStateFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      favicon: 'basic',
    }
  }
  return `
        __typename
        description

    ${
      fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``
    }
  
faviconId
name
state
      `
}

export interface CustomSignedUrlFields {
  urls?: MediaUrlsFields
}
export type SignedUrlFields = 'basic' | 'all' | CustomSignedUrlFields

export const SignedUrlGQLFields = (fields: SignedUrlFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      urls: 'basic',
    }
  }
  return `
        __typename
        fields
mediaDownloadUrl
mediaId
mediaUrl
signedUrl

    ${
      fields.urls
        ? `
      urls {
        ${MediaUrlsGQLFields(fields.urls)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomSlateFields {
  blocks?: BlockFields
  restrictions?: SlateRestrictionsFields
}
export type SlateFields = 'basic' | 'all' | CustomSlateFields

export const SlateGQLFields = (fields: SlateFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      blocks: 'basic',
      restrictions: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.blocks
        ? `
      blocks {
        ${BlockGQLFields(fields.blocks)}
      }
    `
        : ``
    }
  
id

    ${
      fields.restrictions
        ? `
      restrictions {
        ${SlateRestrictionsGQLFields(fields.restrictions)}
      }
    `
        : ``
    }
  
rootBlock
      `
}

export type SlateRestrictionsFields = 'basic' | 'all' | Record<string, never>

export const SlateRestrictionsGQLFields = (fields: SlateRestrictionsFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        lockedChildrenBlocks
nonEditableBlocks
nonRemovableBlocks
      `
}

export type SsoUrlFields = 'basic' | 'all' | Record<string, never>

export const SsoUrlGQLFields = (fields: SsoUrlFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        url
      `
}

export interface CustomTemplateFields {
  apps?: AppFields
  banner?: MediaFields
  embeds?: EmbedFields
  favicon?: MediaFields
  hubContent?: HubContentFields
  image?: MediaFields
  images?: MediaFields
  network?: NetworkFields
  requiredTemplates?: TemplateFields
  slate?: SlateFields
}
export type TemplateFields = 'basic' | 'all' | CustomTemplateFields

export const TemplateGQLFields = (fields: TemplateFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      apps: 'basic',
      banner: 'basic',
      embeds: 'basic',
      favicon: 'basic',
      hubContent: 'basic',
      image: 'basic',
      images: 'basic',
      network: 'basic',
      requiredTemplates: 'basic',
      slate: 'basic',
    }
  }
  return `
        __typename
        about
appIds

    ${
      fields.apps
        ? `
      apps {
        ${AppGQLFields(fields.apps)}
      }
    `
        : ``
    }
  
authorName
authorUrl

    ${
      fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``
    }
  
bannerId
categories
comingSoon
createdAt
createdById
description
embedIds

    ${
      fields.embeds
        ? `
      embeds {
        ${EmbedGQLFields(fields.embeds)}
      }
    `
        : ``
    }
  
entityProperties
entityType

    ${
      fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``
    }
  
faviconId

    ${
      fields.hubContent
        ? `
      hubContent {
        ${HubContentGQLFields(fields.hubContent)}
      }
    `
        : ``
    }
  
hubContentId
id

    ${
      fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``
    }
  
imageId
imageIds

    ${
      fields.images
        ? `
      images {
        ${MediaGQLFields(fields.images)}
      }
    `
        : ``
    }
  
installed
name

    ${
      fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``
    }
  
networkId
onFreePlan
privacyPolicyUrl
requiredTemplateIds

    ${
      fields.requiredTemplates
        ? `
      requiredTemplates {
        ${TemplateGQLFields(fields.requiredTemplates)}
      }
    `
        : ``
    }
  

    ${
      fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``
    }
  
slug
standing
status
termsOfServiceUrl
updatedAt
updatedById
      `
}

export type TemplateDataFields = 'basic' | 'all' | Record<string, never>

export const TemplateDataGQLFields = (fields: TemplateDataFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        data
memberId
preHeaderText
subject
      `
}

export interface CustomTemplateEdgeFields {
  node?: TemplateFields
}
export type TemplateEdgeFields = 'basic' | 'all' | CustomTemplateEdgeFields

export const TemplateEdgeGQLFields = (fields: TemplateEdgeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      node: 'basic',
    }
  }
  return `
        __typename
        cursor

    ${
      fields.node
        ? `
      node {
        ${TemplateGQLFields(fields.node)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomThemeFields {
  colorTokens?: ThemeColorTokensFields
  colors?: ThemeColorsFields
  typography?: ThemeTokenFields
}
export type ThemeFields = 'basic' | 'all' | CustomThemeFields

export const ThemeGQLFields = (fields: ThemeFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      colorTokens: 'basic',
      colors: 'basic',
      typography: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.colorTokens
        ? `
      colorTokens {
        ${ThemeColorTokensGQLFields(fields.colorTokens)}
      }
    `
        : ``
    }
  

    ${
      fields.colors
        ? `
      colors {
        ${ThemeColorsGQLFields(fields.colors)}
      }
    `
        : ``
    }
  
id
name

    ${
      fields.typography
        ? `
      typography {
        ${ThemeTokenGQLFields(fields.typography)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomThemeColorFields {
  weights?: ThemeTokenFields
}
export type ThemeColorFields = 'basic' | 'all' | CustomThemeColorFields

export const ThemeColorGQLFields = (fields: ThemeColorFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      weights: 'basic',
    }
  }
  return `
        __typename
        key

    ${
      fields.weights
        ? `
      weights {
        ${ThemeTokenGQLFields(fields.weights)}
      }
    `
        : ``
    }
  
      `
}

export type ThemeColorTokenFields = 'basic' | 'all' | Record<string, never>

export const ThemeColorTokenGQLFields = (fields: ThemeColorTokenFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        key
value
      `
}

export interface CustomThemeColorTokensFields {
  dark?: ThemeColorTokenFields
  light?: ThemeColorTokenFields
}
export type ThemeColorTokensFields =
  | 'basic'
  | 'all'
  | CustomThemeColorTokensFields

export const ThemeColorTokensGQLFields = (fields: ThemeColorTokensFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      dark: 'basic',
      light: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.dark
        ? `
      dark {
        ${ThemeColorTokenGQLFields(fields.dark)}
      }
    `
        : ``
    }
  

    ${
      fields.light
        ? `
      light {
        ${ThemeColorTokenGQLFields(fields.light)}
      }
    `
        : ``
    }
  
      `
}

export interface CustomThemeColorsFields {
  dark?: ThemeColorFields
  light?: ThemeColorFields
}
export type ThemeColorsFields = 'basic' | 'all' | CustomThemeColorsFields

export const ThemeColorsGQLFields = (fields: ThemeColorsFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {
      dark: 'basic',
      light: 'basic',
    }
  }
  return `
        __typename
        
    ${
      fields.dark
        ? `
      dark {
        ${ThemeColorGQLFields(fields.dark)}
      }
    `
        : ``
    }
  

    ${
      fields.light
        ? `
      light {
        ${ThemeColorGQLFields(fields.light)}
      }
    `
        : ``
    }
  
      `
}

export type ThemeTokenFields = 'basic' | 'all' | Record<string, never>

export const ThemeTokenGQLFields = (fields: ThemeTokenFields) => {
  if (fields === 'basic') {
    fields = {}
  }
  if (fields === 'all') {
    fields = {}
  }
  return `
        __typename
        key
value
      `
}

export const QueryFunctions = {
  app: (fields: AppFields) => gql`
      query app($id: ID
$slug: String) {
        app(id: $id
slug: $slug) {
          ${AppGQLFields(fields)}
        }
      }
    `,
  appCollaborators: (fields: AppCollaboratorFields) => gql`
      query appCollaborators($appId: String!) {
        appCollaborators(appId: $appId) {
          ${AppCollaboratorGQLFields(fields)}
        }
      }
    `,
  appPublications: (fields: AppPublicationFields) => gql`
      query appPublications($appId: ID!) {
        appPublications(appId: $appId) {
          ${AppPublicationGQLFields(fields)}
        }
      }
    `,
  appSettings: (fields: AppSettingsFields) => gql`
      query appSettings($context: PermissionContext!
$entityId: ID
$networkId: ID!) {
        appSettings(context: $context
entityId: $entityId
networkId: $networkId) {
          ${AppSettingsGQLFields(fields)}
        }
      }
    `,
  apps: (fields: PaginatedAppFields) => gql`
      query apps($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$standing: StoreItemStanding
$status: StoreItemStatus) {
        apps(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
standing: $standing
status: $status) {
          ${PaginatedAppGQLFields(fields)}
        }
      }
    `,
  authMember: (fields: GlobalMemberFields) => gql`
      query authMember {
        authMember {
          ${GlobalMemberGQLFields(fields)}
        }
      }
    `,
  checkAppSlugAvailability: (fields: AvailabilityFields) => gql`
      query checkAppSlugAvailability($slug: String!) {
        checkAppSlugAvailability(slug: $slug) {
          ${AvailabilityGQLFields(fields)}
        }
      }
    `,
  dynamicBlock: (fields: DynamicBlockFields) => gql`
      query dynamicBlock($appId: ID!
$blockId: ID!) {
        dynamicBlock(appId: $appId
blockId: $blockId) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
  dynamicBlocks: (fields: PaginatedDynamicBlockFields) => gql`
      query dynamicBlocks($after: String
$appId: ID!
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean) {
        dynamicBlocks(after: $after
appId: $appId
before: $before
limit: $limit
offset: $offset
reverse: $reverse) {
          ${PaginatedDynamicBlockGQLFields(fields)}
        }
      }
    `,
  embed: (fields: EmbedFields) => gql`
      query embed($input: EmbedInput!) {
        embed(input: $input) {
          ${EmbedGQLFields(fields)}
        }
      }
    `,
  eventTypes: (fields: EventTypeFields) => gql`
      query eventTypes {
        eventTypes {
          ${EventTypeGQLFields(fields)}
        }
      }
    `,
  globalToken: (fields: GlobalTokenFields) => gql`
      query globalToken($input: GlobalTokenInput!) {
        globalToken(input: $input) {
          ${GlobalTokenGQLFields(fields)}
        }
      }
    `,
  limitedToken: (fields: AppTokenFields) => gql`
      query limitedToken($context: PermissionContext
$entityId: String
$impersonateMemberId: String
$networkId: String!) {
        limitedToken(context: $context
entityId: $entityId
impersonateMemberId: $impersonateMemberId
networkId: $networkId) {
          ${AppTokenGQLFields(fields)}
        }
      }
    `,
  loginWithSsoCode: (fields: GlobalTokenFields) => gql`
      query loginWithSsoCode($input: LoginWithSsoCodeInput!) {
        loginWithSsoCode(input: $input) {
          ${GlobalTokenGQLFields(fields)}
        }
      }
    `,
  media: (fields: MediaFields) => gql`
      query media($id: ID!) {
        media(id: $id) {
          ${MediaGQLFields(fields)}
        }
      }
    `,
  networkOtp: (fields: NetworkOtpFields) => gql`
      query networkOtp($input: LoginNetwork!) {
        networkOtp(input: $input) {
          ${NetworkOtpGQLFields(fields)}
        }
      }
    `,
  networks: (fields: NetworkFields) => gql`
      query networks {
        networks {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
  shortcut: (fields: ShortcutFields) => gql`
      query shortcut($appId: String!
$id: String!) {
        shortcut(appId: $appId
id: $id) {
          ${ShortcutGQLFields(fields)}
        }
      }
    `,
  shortcuts: (fields: PaginatedShortcutFields) => gql`
      query shortcuts($after: String
$appId: String!
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean) {
        shortcuts(after: $after
appId: $appId
before: $before
limit: $limit
offset: $offset
reverse: $reverse) {
          ${PaginatedShortcutGQLFields(fields)}
        }
      }
    `,
  ssoUrl: (fields: SsoUrlFields) => gql`
      query ssoUrl($input: SsoUrlInput!) {
        ssoUrl(input: $input) {
          ${SsoUrlGQLFields(fields)}
        }
      }
    `,
  templates: (fields: PaginatedTemplateFields) => gql`
      query templates($after: String
$before: String
$entityTypes: [TemplateEntityType!]
$limit: Int!
$offset: Int
$reverse: Boolean
$status: StoreItemStatus) {
        templates(after: $after
before: $before
entityTypes: $entityTypes
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedTemplateGQLFields(fields)}
        }
      }
    `,
}

export const MutationFunctions = {
  acceptCollaboratorInvitation: (fields: InvitationAcceptResultFields) => gql`
      mutation acceptCollaboratorInvitation($input: CollaboratorInvitationInput!) {
        acceptCollaboratorInvitation(input: $input) {
          ${InvitationAcceptResultGQLFields(fields)}
        }
      }
    `,
  addAppCollaborator: (fields: AppCollaboratorFields) => gql`
      mutation addAppCollaborator($appId: String!
$input: AddAppCollaboratorInput!) {
        addAppCollaborator(appId: $appId
input: $input) {
          ${AppCollaboratorGQLFields(fields)}
        }
      }
    `,
  createApp: (fields: AppFields) => gql`
      mutation createApp($input: CreateAppInput!) {
        createApp(input: $input) {
          ${AppGQLFields(fields)}
        }
      }
    `,
  createDynamicBlock: (fields: DynamicBlockFields) => gql`
      mutation createDynamicBlock($appId: ID!
$input: CreateDynamicBlockInput!) {
        createDynamicBlock(appId: $appId
input: $input) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
  createEmojis: (fields: EmojiFields) => gql`
      mutation createEmojis($input: [CreateEmojiInput!]!) {
        createEmojis(input: $input) {
          ${EmojiGQLFields(fields)}
        }
      }
    `,
  createImages: (fields: SignedUrlFields) => gql`
      mutation createImages($input: [CreateImageInput!]!) {
        createImages(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
  createNetwork: (fields: NetworkOtpFields) => gql`
      mutation createNetwork($input: CreateNetwork!) {
        createNetwork(input: $input) {
          ${NetworkOtpGQLFields(fields)}
        }
      }
    `,
  createPostTypeTemplate: (fields: TemplateFields) => gql`
      mutation createPostTypeTemplate($input: CreatePostTypeTemplateInput!) {
        createPostTypeTemplate(input: $input) {
          ${TemplateGQLFields(fields)}
        }
      }
    `,
  createShortcut: (fields: ShortcutFields) => gql`
      mutation createShortcut($appId: String!
$input: CreateShortcutInput!) {
        createShortcut(appId: $appId
input: $input) {
          ${ShortcutGQLFields(fields)}
        }
      }
    `,
  deleteApp: (fields: ActionFields) => gql`
      mutation deleteApp($id: ID!) {
        deleteApp(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  deleteAppSetting: (fields: AppSettingsFields) => gql`
      mutation deleteAppSetting($context: PermissionContext!
$entityId: ID
$networkId: ID!) {
        deleteAppSetting(context: $context
entityId: $entityId
networkId: $networkId) {
          ${AppSettingsGQLFields(fields)}
        }
      }
    `,
  deleteDynamicBlock: (fields: ActionFields) => gql`
      mutation deleteDynamicBlock($appId: ID!
$blockId: ID!) {
        deleteDynamicBlock(appId: $appId
blockId: $blockId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  deleteNetwork: (fields: ActionFields) => gql`
      mutation deleteNetwork($input: DeleteNetworkInput!) {
        deleteNetwork(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  deleteShortcut: (fields: ActionFields) => gql`
      mutation deleteShortcut($appId: String!
$id: ID!) {
        deleteShortcut(appId: $appId
id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  disableDefaultDynamicBlock: (fields: ActionFields) => gql`
      mutation disableDefaultDynamicBlock($appId: ID!
$key: DefaultDynamicBlockKeys!) {
        disableDefaultDynamicBlock(appId: $appId
key: $key) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  enableDefaultDynamicBlock: (fields: DynamicBlockFields) => gql`
      mutation enableDefaultDynamicBlock($appId: ID!
$input: EnableDefaultDynamicBlockInput!
$key: DefaultDynamicBlockKeys!) {
        enableDefaultDynamicBlock(appId: $appId
input: $input
key: $key) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
  joinReferralProgram: (fields: GlobalMemberFields) => gql`
      mutation joinReferralProgram {
        joinReferralProgram {
          ${GlobalMemberGQLFields(fields)}
        }
      }
    `,
  publishApp: (fields: ActionFields) => gql`
      mutation publishApp($id: ID!) {
        publishApp(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  publishAppPrivately: (fields: AppPublicationFields) => gql`
      mutation publishAppPrivately($appId: ID!
$networkId: ID!) {
        publishAppPrivately(appId: $appId
networkId: $networkId) {
          ${AppPublicationGQLFields(fields)}
        }
      }
    `,
  regenerateClientSecret: (fields: AppFields) => gql`
      mutation regenerateClientSecret($appId: ID!) {
        regenerateClientSecret(appId: $appId) {
          ${AppGQLFields(fields)}
        }
      }
    `,
  removeAppCollaborator: (fields: ActionFields) => gql`
      mutation removeAppCollaborator($appId: String!
$collaboratorId: String!) {
        removeAppCollaborator(appId: $appId
collaboratorId: $collaboratorId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  requestGlobalTokenCode: (fields: ActionFields) => gql`
      mutation requestGlobalTokenCode($input: RequestGlobalTokenInput!) {
        requestGlobalTokenCode(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  resendGlobalTokenCode: (fields: ActionFields) => gql`
      mutation resendGlobalTokenCode($input: RequestGlobalTokenInput!) {
        resendGlobalTokenCode(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  sendNotifications: (fields: SendNotificationsFields) => gql`
      mutation sendNotifications($input: AppNotificationInput!) {
        sendNotifications(input: $input) {
          ${SendNotificationsGQLFields(fields)}
        }
      }
    `,
  testAppWebhook: (fields: ActionFields) => gql`
      mutation testAppWebhook($appId: ID!
$input: TestAppWebhookInput!) {
        testAppWebhook(appId: $appId
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  unPublishAppPrivately: (fields: ActionFields) => gql`
      mutation unPublishAppPrivately($appId: ID!
$networkId: ID!) {
        unPublishAppPrivately(appId: $appId
networkId: $networkId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  unpublishApp: (fields: ActionFields) => gql`
      mutation unpublishApp($id: ID!) {
        unpublishApp(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
  updateApp: (fields: AppFields) => gql`
      mutation updateApp($id: ID!
$input: UpdateAppInput!) {
        updateApp(id: $id
input: $input) {
          ${AppGQLFields(fields)}
        }
      }
    `,
  updateAppSetting: (fields: AppSettingsFields) => gql`
      mutation updateAppSetting($context: PermissionContext!
$entityId: ID
$networkId: ID!
$settings: String!) {
        updateAppSetting(context: $context
entityId: $entityId
networkId: $networkId
settings: $settings) {
          ${AppSettingsGQLFields(fields)}
        }
      }
    `,
  updateAuthMember: (fields: GlobalMemberFields) => gql`
      mutation updateAuthMember($input: UpdateGlobalMemberInput!) {
        updateAuthMember(input: $input) {
          ${GlobalMemberGQLFields(fields)}
        }
      }
    `,
  updateDynamicBlock: (fields: DynamicBlockFields) => gql`
      mutation updateDynamicBlock($appId: ID!
$blockId: ID!
$input: UpdateDynamicBlockInput!) {
        updateDynamicBlock(appId: $appId
blockId: $blockId
input: $input) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
  updateShortcut: (fields: ShortcutFields) => gql`
      mutation updateShortcut($appId: String!
$id: ID!
$input: UpdateShortcutInput!) {
        updateShortcut(appId: $appId
id: $id
input: $input) {
          ${ShortcutGQLFields(fields)}
        }
      }
    `,
  validateEmail: (fields: EmailValidationResultFields) => gql`
      mutation validateEmail($input: RequestGlobalTokenInput!) {
        validateEmail(input: $input) {
          ${EmailValidationResultGQLFields(fields)}
        }
      }
    `,
}
